// Lazy Sentry init — only loads when REACT_APP_SENTRY_DSN is set.
// Install: yarn add @sentry/react
export async function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN
  if (!dsn) return
  try {
    const Sentry = await import("@sentry/react")
    Sentry.init({
      dsn,
      environment: process.env.NODE_ENV ?? "development",
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0.1,
    })
    // eslint-disable-next-line no-console
    console.info("[sentry] initialized")
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[sentry] SDK not installed — run `yarn add @sentry/react`", e)
  }
}
